<template>
  <form ref="prescriptionForm" class="form" novalidate @submit.prevent="submit">
    <div class="row">
      <div class="col">
        <h3 class="title">Patient information</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-paw" />
          <input
            id="patient_first_name"
            v-model="prescription.patient_first_name"
            :class="{ error: $v.prescription.patient_first_name.$error }"
            type="text"
            name="patient_first_name"
            placeholder="Patient First Name"
            required="required"
            class="input"
            @input="$v.prescription.patient_first_name.$touch()"
          >
          <label
            v-if="
              $v.prescription.patient_first_name.$error &&
                !$v.prescription.patient_first_name.required
            "
            class="error"
            for="name"
          >This field is required.</label
          >
        </div>
      </div>
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-paw" />
          <input
            id="patient_last_name"
            v-model="prescription.patient_last_name"
            :class="{ error: $v.prescription.patient_last_name.$error }"
            type="text"
            name="patient_last_name"
            placeholder="Patient Last Name"
            required="required"
            class="input"
            @input="$v.prescription.patient_last_name.$touch()"
          >
          <label
            v-if="
              $v.prescription.patient_last_name.$error &&
                !$v.prescription.patient_last_name.required
            "
            class="error"
            for="name"
          >This field is required.</label
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-paw" />
          <input
            id="species"
            v-model="prescription.species"
            :class="{ error: $v.prescription.species.$error }"
            type="text"
            name="species"
            placeholder="Species"
            required="required"
            class="input"
            @input="$v.prescription.species.$touch()"
          >
          <label
            v-if="
              $v.prescription.species.$error &&
                !$v.prescription.species.required
            "
            class="error"
            for="name"
          >This field is required.</label
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-paw" />
          <input
            id="breed"
            v-model="prescription.breed"
            :class="{ error: $v.prescription.breed.$error }"
            type="text"
            name="breed"
            placeholder="Breed"
            required="required"
            class="input"
            @input="$v.prescription.breed.$touch()"
          >
          <label
            v-if="
              $v.prescription.breed.$error && !$v.prescription.breed.required
            "
            class="error"
            for="name"
          >This field is required.</label
          >
        </div>
      </div>
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-paw" />
          <input
            id="weight"
            v-model="prescription.weight"
            :class="{ error: $v.prescription.weight.$error }"
            type="text"
            name="weight"
            placeholder="Weight in Lbs."
            required="required"
            class="input"
            @input="$v.prescription.weight.$touch()"
          >
          <label
            v-if="
              $v.prescription.weight.$error && !$v.prescription.weight.required
            "
            class="error"
            for="name"
          >This field is required.</label
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-paw" />
          <input
            v-mask="'##/##/####'"
            id="date_of_birth"
            :class="{ error: $v.prescription.date_of_birth.$error }"
            v-model="prescription.date_of_birth"
            name="date_of_birth"
            placeholder="Date of Birth: mm/dd/yyyy"
            class="input"
            @input="$v.prescription.date_of_birth.$touch()"
          >
          <label
            v-if="
              $v.prescription.date_of_birth.$error &&
                !$v.prescription.date_of_birth.required
            "
            class="error"
            for="name"
          >This field is required.</label>
          <label
            v-if="
              $v.prescription.date_of_birth.$error &&
                !$v.prescription.date_of_birth.isValidDate
            "
            class="error"
            for="name"
          >Valid date in format 'MM/DD/YYYY' is required.</label>
        </div>
      </div>
      <div class="col">
        <div class="select-wrap">
          <div class="icon icon-paw" />
          <select v-model.trim="prescription.sex" name="sex" class="select">
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
          <span v-if="!prescription.sex" class="placeholder">Sex</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-paw" />
          <input
            id="allergies"
            v-model="prescription.allergies"
            type="text"
            name="allergies"
            placeholder="List of Known Allergies"
            required="required"
            class="input"
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-paw" />
          <input
            id="patient_city"
            v-model="prescription.patient_city"
            :class="{ error: $v.prescription.patient_city.$error }"
            type="text"
            name="patient_city"
            placeholder="Patient City"
            required="required"
            class="input"
            @input="$v.prescription.patient_city.$touch()"
          >
          <label
            v-if="
              $v.prescription.patient_city.$error &&
                !$v.prescription.patient_city.required
            "
            class="error"
            for="patient_city"
          >This field is required.</label
          >
        </div>
      </div>
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-paw" />
          <input
            id="patient_state"
            v-model="prescription.patient_state"
            :class="{ error: $v.prescription.patient_state.$error }"
            type="text"
            name="patient_state"
            placeholder="Patient State"
            required="required"
            class="input"
            @input="$v.prescription.patient_state.$touch()"
          >
          <label
            v-if="
              $v.prescription.patient_state.$error &&
                !$v.prescription.patient_state.required
            "
            class="error"
            for="patient_state"
          >This field is required.</label
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-paw" />
          <input
            id="patient_address"
            v-model="prescription.patient_address"
            :class="{ error: $v.prescription.patient_address.$error }"
            type="text"
            name="patient_address"
            placeholder="Patient Address"
            required="required"
            class="input"
            @input="$v.prescription.patient_address.$touch()"
          >
          <label
            v-if="
              $v.prescription.patient_address.$error &&
                !$v.prescription.patient_address.required
            "
            class="error"
            for="patient_address"
          >This field is required.</label
          >
        </div>
      </div>
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-paw" />
          <input
            id="patient_zipcode"
            v-model="prescription.patient_zipcode"
            :class="{ error: $v.prescription.patient_zipcode.$error }"
            type="text"
            name="patient_zipcode"
            placeholder="Zip Code"
            required="required"
            class="input"
            @input="$v.prescription.patient_zipcode.$touch()"
          >
          <label
            v-if="
              $v.prescription.patient_zipcode.$error &&
                !$v.prescription.patient_zipcode.required
            "
            class="error"
            for="patient_zipcode"
          >This field is required.</label
          >
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-mail" />
          <input
            id="patient_email"
            v-model="prescription.patient_email"
            :class="{ error: $v.prescription.patient_email.$error }"
            type="email"
            name="patient_email"
            placeholder="Patient Email"
            required="required"
            class="input"
            @input="$v.prescription.patient_email.$touch()"
          >
          <label
            v-if="
              $v.prescription.patient_email.$error &&
                !$v.prescription.patient_email.email
            "
            class="error"
            for="patient_email"
          >This field is required.</label
          >
        </div>
      </div>
        <div class="col">
          <div class="input-wrap">
            <div class="icon icon-phone" />
            <input
              v-mask="'(###) ###-####'"
              id="patient_phone"
              v-model="prescription.patient_phone"
              :class="{ error: $v.prescription.patient_phone.$error }"
              type="text"
              name="patient_phone"
              placeholder="Patient phone"
              required="required"
              class="input"
              @input="$v.prescription.patient_phone.$touch()">
            <label
              v-if="$v.prescription.patient_phone.$error && !$v.prescription.patient_phone.required"
              class="error"
              for="patient_phone">This field is required.</label>
            <label
              v-if="$v.prescription.patient_phone.$error && !$v.prescription.patient_phone.minLength"
              class="error"
              for="patient_phone"
            >Minimal length is 10 numbers.</label>
        </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3 class="title mt-40 mt-d-20">Prescription information</h3>
      </div>
    </div>
    <div v-if="false" class="row">
      <div class="col">
        <div class="select-wrap">
          <div class="icon icon-card" />
          <select
            v-model.trim="prescription.new_rx"
            name="new_rx"
            class="select"
          >
            <option value="new">New Rx</option>
            <option value="refill">New Rx</option>
          </select>
          <span
            v-if="
              undefined === prescription.new_rx || prescription.new_rx === ''
            "
            class="placeholder"
          >New Rx</span
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-calendar" />
          <input
            v-mask="'##/##/####'"
            id="prescription_date"
            :class="{ error: $v.prescription.prescription_date.$error }"
            v-model="prescription.prescription_date"
            name="date_of_birth"
            placeholder="Date: mm/dd/yyyy"
            class="input"
            @input="$v.prescription.prescription_date.$touch()"
          >
          <label
            v-if="
              $v.prescription.prescription_date.$error &&
                !$v.prescription.prescription_date.isValidDate
            "
            class="error"
            for="name"
          >Valid date in format 'MM/DD/YYYY' is required.</label>
        </div>
      </div>
      <div class="col" />
    </div>
    <!-- <h4>Drug List:</h4> -->
    </br>
    </br>
    <p class="border-alert">To order an item not listed, please call <a href="tel:1-800-481-1729">1-800-481-1729</a></p>
    <div class="row">
      <div class="col">
        <div class="checkbox-wrap gray">
          <div class="checkbox">
            <input
              v-model="prescription.bill_to_clinic"
              type="checkbox"
              name="bill_to_clinic"
              @change="toggleBill('clinic')"
            >
            <div class="icon check" />
            <div class="label">Bill to Clinic</div>
          </div>

        </div>
      </div>
      <div class="col">
        <div class="checkbox-wrap gray">
          <div class="checkbox">
            <input
              v-model="prescription.bill_to_owner"
              type="checkbox"
              name="bill_to_owner"
              @change="toggleBill('owner')"
            >
            <div class="icon check" />
            <div class="label">Bill to Owner</div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-for="(drug, index) in prescription.drugs"
      :key="index"
      class="drug--container"
    >
      <div class="row">
        <div class="col">
          <div class="input-wrap">
            <div class="icon icon-drugs" />
            <v-select
              :class="{
                input: true,
                error: $v.prescription.drugs.$each[index].drug.$error
              }"
              :options="drugs"
              v-model="drug.drug"
              label="name"
              placeholder="Drug"
              @input="reloadForms(index)"
            />
            <label
              v-if="
                $v.prescription.drugs.$each[index].drug.$error &&
                  !$v.prescription.drugs.$each[index].drug.required
              "
              class="error"
              for="name"
            >This field is required.</label
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col input-wrap">
          <div
            :class="{
              error: $v.prescription.drugs.$each[index].form.$error,
              disabled: drug.forms.length === 0 || drug.drug === undefined
            }"
            class="select-wrap"
          >
            <div class="icon icon-drugs" />
            <select
              v-model.trim="drug.form"
              :disabled="drug.forms.length === 0 || drug.drug === undefined"
              name="form"
              class="select"
              @change="reloadStrength(index)"
            >
              <option
                v-for="(value, key) in drug.forms"
                :value="value.value"
                :key="key"
              >{{ value.name }}</option
              >
            </select>
            <span
              v-if="undefined === drug.form || drug.form === ''"
              class="placeholder"
            >Form</span
            >
          </div>
          <label
            v-if="
              $v.prescription.drugs.$each[index].form.$error &&
                !$v.prescription.drugs.$each[index].form.required
            "
            class="error"
            for="name"
          >This field is required.</label
          >
        </div>
        <div class="col input-wrap">
          <div
            :class="{
              error: $v.prescription.drugs.$each[index].strength.$error,
              disabled: drug.strengths.length === 0 || drug.form === undefined,
              'select-wrap': !drug.manualStrength
            }"
          >
            <div class="icon icon-drugs" />
            <select
              v-if="!drug.manualStrength"
              v-model.trim="drug.strength"
              :disabled="drug.strengths.length === 0 || drug.form === undefined"
              name="strength"
              placeholder="Strength"
              class="select"
              @change="reloadPackSize($event, index)"
            >
              <option
                v-for="(value, key) in drug.strengths"
                :value="value.value"
                :key="key"
                :data-cost="value.cost"
              >{{ value.name }}</option
              >
            </select>
            <input v-else v-model.trim="drug.strength" :disabled="drug.form === undefined" name="strength" placeholder="Strength" class="input" ref="strmanual" @change="reloadPackSize($event, index)" />
            <button v-if="drug.manualStrength" @click="resetManualDrugForm(index)" type="button" class="vs__clear" style="position: absolute;top: 18px;right: 10px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
                <path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"/>
              </svg>
            </button>
            <span
              v-if="!drug.manualStrength && (undefined === drug.strength || drug.strength === '')"
              class="placeholder"
            >Strength</span
            >
          </div>
          <label
            v-if="
              $v.prescription.drugs.$each[index].strength.$error &&
                !$v.prescription.drugs.$each[index].strength.required
            "
            class="error"
            for="name">This field is required.
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col input-wrap">
          <div class="icon icon-drugs" />
          <input ref="quantity" v-model.trim="drug.pack_size" :disabled="drug.strength === undefined" name="quantity" placeholder="Quantity" class="input number" @change="quantitySize($event)" @input="$v.prescription.drugs.$each[index].pack_size.$touch()" >
          <label
            v-if="
              $v.prescription.drugs.$each[index].pack_size.$error &&
                !$v.prescription.drugs.$each[index].pack_size.required
            "
            class="error"
            for="name">This field is required.</label>
        </div>
        <div class="col input-wrap">
          <div :class="{ disabled: flavors.length === 0 || !(drug.withFlavors || false) }" class="select-wrap">
            <div class="icon icon-drugs" />
            <select
              v-model.trim="drug.flavor"
              :disabled="
                flavors.length === 0 || !(drug.withFlavors || false)
              "
              name="flavor"
              placeholder="Flavor"
              class="select"
            >
              <option
                v-for="(value, key) in flavors"
                :value="value.value"
                :key="key"
              >{{ value.name }}</option
              >
            </select>
            <span
              v-if="undefined === drug.flavor || drug.flavor === ''"
              class="placeholder"
            >Flavor</span
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col input-wrap">
          <div class="select-wrap" :class="{ error: $v.prescription.compounding_reason.$error }">
              <div class="icon icon-drugs"></div>
                <select v-model.trim="prescription.compounding_reason"  name="compounding_reason" class="select">
                    <option value="10. Animal cannot be dosed/pilled w/FDA approved product">10. Animal cannot be dosed/pilled w/FDA approved product</option>
                    <option value="11. FDA approved drug cannot accurately be divided into smaller dose">11. FDA approved drug cannot accurately be divided into smaller dose</option>
                    <option value="12. Animal allergic to ingredient in FDA approved product">12. Animal allergic to ingredient in FDA approved product</option>
                    <option value="13. Animal needs drug ingredients not found in FDA approved product">13. Animal needs drug ingredients not found in FDA approved product</option>
                    <option value="14. Animal cannot be dosed numerous times daily with FDA approved drug">14. Animal cannot be dosed numerous times daily with FDA approved drug</option>
                    <option value="15. Drug not available in FDA approved form/discontinued">15. Drug not available in FDA approved form/discontinued</option>
                    <option value="16. Treatment requires use of dosage form not available in FDA approved product">16. Treatment requires use of dosage form not available in FDA approved product</option>
                    <option value="17. Animal cannot ingest commercially available FDA approved product (chew tab/liquid required)">17. Animal cannot ingest commercially available FDA approved product (chew tab/liquid required)</option>
                    <option value="18. FDA approved drug is unavailable/shortage/backordered">18. FDA approved drug is unavailable/shortage/backordered</option>
                    <option value="19. Animal will not ingest FDA approved product (chew tab/liquid required)">19. Animal will not ingest FDA approved product (chew tab/liquid required)</option>
                    <option value="20. Animal cannot have ingredient in FDA approved product (sugar, etc)">20. Animal cannot have ingredient in FDA approved product (sugar, etc)</option>
                    <option value="21. Animal dose is higher than the FDA approved product, too large of quantity required">21. Animal dose is higher than the FDA approved product, too large of quantity required</option>
                    <option value="22. Drug combo is not available in FDA approved product">22. Drug combo is not available in FDA approved product</option>
                </select>
              <span v-if="!prescription.compounding_reason" class="placeholder compounding_reason">Compounding Reason</span>
          </div>
          <label
           v-if="$v.prescription.compounding_reason.$error && !$v.prescription.compounding_reason.required"
           class="error"
           for="compounding_reason"
         >This field is required.</label>
      </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="select-wrap">
              <div class="icon icon-drugs"></div>
                <select v-model.trim="prescription.number_of_refills" name="placeholder_number_of_refils" class="select">
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="PRN">PRN</option>
                </select>
              <span v-if="!prescription.number_of_refills" class="placeholder placeholder_number_of_refils"># of Refils</span>
          </div>
      </div>
      </div>
    </div>
      <div v-if="prescription.bill_to_owner === false">
        <div class="row" v-if ="total !== 'NaN' && total !== 0">
         <div class="col">
            <h4 class="prescription-cost">Prescription Cost: <span>${{ total }}</span></h4>
          </div>
       </div>
       <div class="row" v-else-if="total == 'NaN'">
          <div class="col">
            <div class="prescription-cost"><span>For custom strengths or flavors, pricing will be determined after prescription is submitted.</span></div>
          </div>
       </div>
     </div>
     <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-paw" />
          <input
            v-model="prescription.sig"
            type="text"
            name="sig"
            placeholder="SIG (Directions)"
            :class="{ error: $v.prescription.sig.$error }"
            class="input"
            @input="$v.prescription.sig.$touch()"
          >
          <label
           v-if="$v.prescription.sig.$error && !$v.prescription.sig.required"
           class="error"
           for="name"
         >This field is required.</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-pen" />
          <textarea
            v-model="prescription.directions"
            name="directions"
            placeholder="Indication & Additional Information"
            class="textarea"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3 class="title mt-40 mt-d-20">5. Shipping</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
      <span v-html="prsdelivery"></span>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p v-if="!billSelected">
          <label class="error" for="name"
          >One of the bill varitant is required.</label
          >
        </p>
        <p v-if="!shipSelected">
          <label class="error" for="name"
          >One of the ship varitant is required.</label
          >
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="checkbox-wrap gray">
          <div class="checkbox">
            <input
              v-model="prescription.ship_to_clinic"
              type="checkbox"
              name="ship_to_clinic"
              @change="toggleShip('clinic')"
            >
            <div class="icon check" />
            <div class="label">Ship to Clinic</div>
          </div>
          <p class="checkbox-text">If shipping to a different clinic please enter the address in the additional information below.</p>
        </div>
      </div>
      <div class="col">
        <div class="checkbox-wrap gray">
          <div class="checkbox">
            <input
              v-model="prescription.ship_to_owner"
              type="checkbox"
              name="ship_to_owner"
              @change="toggleShip('owner')"
            >
            <div class="icon check" />
            <div class="label">Ship to Owner</div>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="checkbox-wrap gray">
          <div class="checkbox">
            <input
              v-model="prescription.bill_to_owner_new"
              type="checkbox"
              name="bill_to_owner_new"
              @change="toggleShip('bill_to_owner_new')"
            >
            <div class="icon check" />
            <div class="label">Ship to Owner w/Signature</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="checkCheckbox()" class="row">
    <div class="row">
      <div class="col">
        <h4 class="title mt-40 mt-d-20">Customer Contacts</h4>
          <div class="checkbox-wrap gray">
            <div class="checkbox">
              <input
                v-model="ship_contact"
                type="checkbox"
                name="ship_contact"
                @change="ship_to_contact"
              >
              <div class="icon check" />
              <div class="label">Click to auto-fill patient address</div>
            </div>
          </div>
        </div>
      </div>

    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-mail" />
          <input
            id="address"
            v-model="prescription.email"
            :class="{ error: $v.prescription.email.$error }"
            type="text"
            name="email"
            placeholder="Email"
            required="required"
            class="input"
            @input="$v.prescription.email.$touch()"
          >
          <label
            v-if="
              $v.prescription.email.$error &&
                !$v.prescription.email.required
            "
            class="error"
            for="name"
          >This field is required.</label>
          <label
            v-if="$v.prescription.email.$error && !$v.prescription.email.email"
            class="error"
            for="name"
          >Valid email is required.</label>
        </div>
      </div>
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-phone" />
          <input
            v-mask="'(###) ###-####'"
            id="city"
            v-model="prescription.phone"
            :class="{ error: $v.prescription.phone.$error }"
            type="text"
            name="phone"
            placeholder="Phone"
            required="required"
            class="input"
            @input="$v.prescription.phone.$touch()"
          >
          <label
            v-if="$v.prescription.phone.$error && !$v.prescription.phone.required"
            class="error"
            for="name"
          >This field is required.</label>
          <label
            v-if="$v.prescription.phone.$error && !$v.prescription.phone.minLength"
            class="error"
            for="name"
          >Minimal length is 10 numbers.</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h4 class="title mt-40 mt-d-20">Customer Address</h4>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-location" />
          <input
            id="address"
            v-model="prescription.address"
            :class="{ error: $v.prescription.address.$error }"
            type="text"
            name="address"
            placeholder="Street Address"
            required="required"
            class="input"
            @input="$v.prescription.address.$touch()"
          >
          <label
            v-if="
              $v.prescription.address.$error &&
                !$v.prescription.address.required
            "
            class="error"
            for="name"
          >This field is required.</label
          >
        </div>
      </div>
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-building" />
          <input
            id="city"
            v-model="prescription.city"
            :class="{ error: $v.prescription.city.$error }"
            type="text"
            name="city"
            placeholder="City"
            required="required"
            class="input"
            @input="$v.prescription.city.$touch()"
          >
          <label
            v-if="$v.prescription.city.$error && !$v.prescription.city.required"
            class="error"
            for="name"
          >This field is required.</label
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-shield" />
          <input
            id="state"
            v-model="prescription.state"
            :class="{ error: $v.prescription.state.$error }"
            type="text"
            name="state"
            placeholder="State / Province / Region"
            required="required"
            class="input"
            @input="$v.prescription.state.$touch()"
          >
          <label
            v-if="
              $v.prescription.state.$error && !$v.prescription.state.required
            "
            class="error"
            for="name"
          >This field is required.</label
          >
        </div>
      </div>
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-mail" />
          <input
            v-mask="getZipMask(prescription.zip)"
            id="zip"
            v-model="prescription.zip"
            :class="{ error: $v.prescription.zip.$error }"
            type="text"
            name="zip"
            placeholder="Zip / Postal Code"
            required="required"
            class="input number"
            @input="$v.prescription.zip.$touch()"
          >
          <label
            v-if="$v.prescription.zip.$error && !$v.prescription.zip.required"
            class="error"
            for="name"
          >This field is required.</label
          >
        </div>
      </div>
    </div>
  </div>
  <div class="row" v-if="this.prescription.bill_to_owner && this.prescription.ship_to_clinic">
    <div class="col">
          <div class="input-wrap">
            <div class="icon icon-phone" />
            <input
              v-mask="'(###) ###-####'"
              id="city"
              v-model="prescription.phone"
              :class="{ error: $v.prescription.phone.$error }"
              type="text"
              name="phone"
              placeholder="Phone"
              required="required"
              class="input"
              @input="$v.prescription.phone.$touch()"
            >
            <label
              v-if="$v.prescription.phone.$error && !$v.prescription.phone.required"
              class="error"
              for="name"
            >This field is required.</label>
            <label
              v-if="$v.prescription.phone.$error && !$v.prescription.phone.minLength"
              class="error"
              for="name"
            >Minimal length is 10 numbers.</label>
          </div>
        </div>
      </div>
    <div class="row">
      <div class="col">
        <h3 class="title mt-40 mt-d-20">6. Additional information</h3>
        <p class="mt-0">
          If shipping to an alternate clinic, please type address below:
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-pen" />
          <textarea
            v-model="prescription.message"
            name="message"
            placeholder="Your Message"
            class="textarea"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-file-wrap">
          <div class="file-wrap" />
          <div class="button">
            <div class="icon icon-upload" />
            <span class="placeholder"
            >File Upload (formats: jpg, pdf, doc, docx 1mb limit)</span
            >
          </div>
          <div class="file-input">
            <input type="file" name="addfile[]" class="input-file clone" >
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <vue-button-spinner
          :is-loading="isLoading"
          :disabled="isLoading"
          :status="status"
          type="submit"
          class="btn wide"
        >
          <span>Send Order</span>
        </vue-button-spinner>
      </div>
      <div class="col" />
    </div>
    <sweet-modal
      ref="new_prescription_modal"
      :blocking="true"
      :hide-close-button="true"
    >
      <div style="text-align: center;">
        <div class="modal-close-btn cross">
          <span class="icon-cross" />
        </div>
        <div class="modal-body">
          <h2 class="title">Success!</h2>
          <div class="notification-block">
            <p>
              You have successfully submitted an order.<br>You should receive your order in 2 business days.
            </p>
            <div class="button-wrap">
              <button
                class="btn modal-close-btn"
                style="margin: 15px auto 0;"
                @click="confirmModal"
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>
    </sweet-modal>
  </form>
</template>

<script>
/* global axios */
import { required, email, minLength } from 'vuelidate/lib/validators'
import { SweetModal } from 'sweet-modal-vue'
import RowItem from './RowItem.vue'
import ZipMask from './../../mixins/ZipMask'
import ValidateScroll from '../../mixins/ValidateScroll'
import { isValidDate } from '../../mixins/DateValidator'

export default {
  name: 'NewPrescription',
  components: {
    SweetModal
  },
  mixins: [ZipMask, ValidateScroll],
  props: ['flavors', 'strengths', 'forms', 'packSizes', 'prsdelivery'],
  data: () => {
    return {
      isLoading: false,
      status: '',
      total: 0,
      cost: 0,
      prescription: {
        manualStrength: false,
        number_of_refills: 0,
        compounding_reason: '',
        sig: '',
        patient_address: '',
        patient_zipcode: '',
        patient_city: '',
        patient_state: '',
        patient_email: '',
        patient_phone: '',
        city: '',
        state: '',
        phone: '',
        email: '',
        address: '',
        zip: '',
       // owner_phone: null,
        prescription_date: new Date().toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric"}),
        drugs: [
          {
            withFlavors: false,
            form: '',
            strength: '',
            pack_size: '',
            flavor: '',
            forms: [],
            strengths: [],
            pack_sizes: [],
            flavors: []
          }
        ],
        sex: '',
        bill_to_clinic: true,
        bill_to_owner: false,
        ship_to_clinic: true,
        ship_to_owner: false,
        bill_to_owner_new: false
      },
      ship_contact: false,
      rowItem: RowItem,
      drugs: []
    }
  },
  validations () {
    let rules = {
      prescription: {
        patient_first_name: {
          required
        },
        patient_last_name: {
          required
        },
        species: {
          required
        },
        patient_address: {
          required
        },
        patient_zipcode: {
          required
        },
        patient_city: {
          required
        },
        patient_state: {
          required
        },
        patient_email: {
          required
        },
        patient_phone: {
          required
        },
        breed: {
          required
        },
        weight: {
          required
        },
        sig: {
          required
        },
        compounding_reason: {
           required
         },
        date_of_birth: {
          required,
          isValidDate (value) {
            return isValidDate(value)
          }
        },
        prescription_date: {
          isValidDate (value) {
            return isValidDate(value)
          }
        },
        drugs: {
          required,
          $each: {
            drug: {
              required
            },
            pack_size: {
              required
            },
            strength: {
              required
            },
            form: {
              required
            }
          }
        }
      }
    }

    if (this.checkCheckbox()) {
      rules.prescription.address = { required }
      rules.prescription.city = { required }
      rules.prescription.state = { required }
      rules.prescription.zip = { required }
      rules.prescription.email = { required, email }
      rules.prescription.phone = { required, minLength: minLength(10) }
    }

    if (this.prescription.bill_to_owner && this.prescription.ship_to_clinic) {
      rules.prescription.phone = { required, minLength: minLength(10) }
    }
    rules.prescription.patient_phone = { required, minLength: minLength(10) }
    rules.prescription.patient_email = { required, email }
    return rules
  },
  computed: {
    shipSelected () {
      return (
        this.prescription.ship_to_clinic || this.prescription.ship_to_owner || this.prescription.bill_to_owner_new
      )
    },
    billSelected () {
      return (
        this.prescription.bill_to_clinic || this.prescription.bill_to_owner
      )
    }
  },
  mounted () {
    let that = this
    axios
      .get('/api/public/drugs-list')
      .then(response => {
        if (response && response.data && response.data.result === 'ok') {
          that.drugs = response.data.drugs
        } else {
          console.log(response.data.message)
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    checkCheckbox () {
     if(this.prescription.bill_to_clinic && this.prescription.ship_to_clinic) {
      return false
     }
     else if(this.prescription.bill_to_clinic && this.prescription.ship_to_owner) {
      return true
     }
     else if(this.prescription.bill_to_clinic && this.prescription.bill_to_owner_new) {
      return true
     }
     else if(this.prescription.bill_to_owner && this.prescription.ship_to_clinic) {
      return false
     }
     else if(this.prescription.bill_to_owner && this.prescription.ship_to_owner) {
      return false
     }
     else if(this.prescription.bill_to_owner && this.prescription.bill_to_owner_new) {
      return true
     }
     else{
      return false
     }
    },
    ship_to_contact (e) {
       if(this.prescription.patient_phone == '' && this.prescription.patient_email == '' && this.prescription.patient_city == '' && this.prescription.patient_state == '' && this.prescription.patient_address == '' && this.prescription.patient_zipcode == '') {
        this.validateWithScroll()
        e.target.checked = false
        this.ship_contact = false
        console.log(this.ship_contact)
      }
      else {
        this.prescription.phone = this.prescription.patient_phone
        this.prescription.email = this.prescription.patient_email
        this.prescription.city = this.prescription.patient_city
        this.prescription.state = this.prescription.patient_state
        this.prescription.address = this.prescription.patient_address
        this.prescription.zip = this.prescription.patient_zipcode
      }
    },
    formattedDisplay (result) {
      return result.name
    },
    toggleBill (type) {
      if (type === 'clinic' && this.prescription.bill_to_owner) {
        this.prescription.bill_to_owner = false
      }
      if (type === 'owner' && this.prescription.bill_to_clinic) {
        this.prescription.bill_to_clinic = false
      }
    },
    toggleShip (type) {
      if (type === 'clinic') {
        this.prescription.ship_to_owner = false
        this.prescription.bill_to_owner_new = false
      }
      if (type === 'owner') {
        this.prescription.ship_to_clinic = false
        this.prescription.bill_to_owner_new = false
      }
      if (type === 'bill_to_owner_new') {
        this.prescription.ship_to_owner = false
        this.prescription.ship_to_clinic = false
      }
      // if (type === 'owner2' && this.prescription.ship_to_owner) {
      //   this.prescription.ship_to_owner = false
      //   this.prescription.ship_to_clinic = false
      // }
    },
    quantitySize (e) {
      if(this.$refs.quantity[0].value){
        this.total = (this.cost * this.$refs.quantity[0].value).toFixed(2)
        if(this.total < 12){
          this.total = 12
        }
      }
    },
    submit () {
      this.validateWithScroll()
      this.prescription.patient_name = this.prescription.patient_first_name + ' ' + this.prescription.patient_last_name
      if (!this.$v.$invalid && this.shipSelected && this.billSelected) {
        this.isLoading = true
        let formData = new FormData()
        for (var key in this.prescription) {
          if (key === 'drugs') {
            formData.append(key, JSON.stringify(this.prescription[key]))
          } else {
            formData.append(key, this.prescription[key])
          }
        }
        // if (this.$refs.strmanual.length > 0) {
        //   this.prescription.manualStrength = true
        // }
        let filesArray = []

        this.$refs.prescriptionForm
          .querySelectorAll('input[type=file]')
          .forEach(item => {
            if (item.files.length !== 0) {
              for (let newFile of item.files) {
                filesArray.push(newFile)
              }
            }
          })

        filesArray.forEach(item => {
          formData.append('documents[]', item)
        })

        axios
          .post('/veterinarians/internal/new-prescription', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            if (response && response.data && response.data.result === 'ok') {
              this.$refs.new_prescription_modal.open()
              this.isLoading = false
            } else {
              console.log(response.data.message)
              this.isLoading = false
            }
          })
          .catch(error => {
            console.log(error)
            this.isLoading = false
          })
      }
    },
    confirmModal () {
      window.location = '/veterinarians/internal'
    },
    getLabel (item) {
      return (item && item.name) || ''
    },
    reloadForms (index) {
      if (
        this.prescription.drugs.length !== 0 &&
        this.prescription.drugs[index].drug
      ) {
        let newDrugs = this.prescription.drugs

        axios
          .post('/api/public/drug-form', { drug: newDrugs[index].drug.id })
          .then(response => {
            newDrugs[index].form = undefined
            newDrugs[index].strength = undefined
            newDrugs[index].pack_size = undefined
            newDrugs[index].flavor = undefined
            if (response && response.data && response.data.result === 'ok') {
              newDrugs[index].forms = response.data.forms
            } else {
              console.log(response.data.message)
            }
            this.prescription.drugs = newDrugs
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        this.prescription.drugs[index].form = undefined
        this.prescription.drugs[index].strength = undefined
        this.prescription.drugs[index].pack_size = undefined
        this.prescription.drugs[index].flavor = undefined

        let that = this
        this.$nextTick(function () {
          that.$v.$reset()
        })
      }
    },
    reloadStrength (index) {
      let newDrugs = this.prescription.drugs
      let that = this

      this.$nextTick(function () {
        that.$v.prescription.drugs.$each[index].form.$touch()
        let formValue = that.prescription.drugs[index].form
        that.prescription.drugs[index].forms.forEach(function (item) {
          if (item.value === formValue) {
            that.prescription.drugs[index].withFlavors = item.with_flavors
            if (!that.prescription.drugs[index].withFlavors) {
              that.prescription.drugs[index].flavor = undefined
            }
          }
        })
      })
      axios
        .post('/api/public/drug-strength', {
          drug: this.prescription.drugs[index].drug.id,
          form: this.prescription.drugs[index].form
        })
        .then(response => {
          newDrugs[index].strength = undefined
          newDrugs[index].manualStrength = false
          this.prescription.manualStrength = false
          newDrugs[index].strengths = []
          if (response && response.data && response.data.result === 'ok') {
            newDrugs[index].strengths = response.data.strengths
          } else {
            console.log(response.data.message)
          }

          this.prescription.drugs = newDrugs
        })
        .catch(error => {
          console.log(error)
        })
    },
    resetManualDrugForm (index) {
      let newDrugs = this.prescription.drugs
      let that = this
      newDrugs[index].strength = (newDrugs[index].strength && newDrugs[index].strength.length !== 0) ? newDrugs[index].strength : ' '

      this.$nextTick(function () {
        newDrugs[index].strength = undefined
        newDrugs[index].manualStrength = false
        that.prescription.manualStrength = false
        that.prescription.drugs = newDrugs

      })
    },
    reloadPackSize (e, index) {
      let that = this

      that.$nextTick(function () {
        if (typeof e.target.select === 'undefined' && that.$refs.strmanual !== 'undefined') {
          if (e.target.options.selectedIndex > -1) {
            that.cost = e.target.options[e.target.options.selectedIndex].dataset.cost
            that.quantitySize(e)
          }
        }
        that.$v.prescription.drugs.$each[index].strength.$touch()
        let strengthValue = that.prescription.drugs[index].strength


        if (!that.prescription.drugs[index].manualStrength && strengthValue === -1) {
          that.prescription.drugs[index].strength = undefined
          that.prescription.drugs[index].manualStrength = true
          that.prescription.manualStrength = true
        }
      })
    }
  }
}
</script>

<style>
h4 {
  margin-top: 28px;
}
.drug--container {
  border-radius: 5px;
  background: #ebe9ea;
  padding: 20px;
  margin: 30px 0;
}
.drug--container:first-of-type {
  margin-top: 13px;
}
.remove--link:hover {
  cursor: pointer;
}
.v-autocomplete-list {
  position: absolute;
  top: 47px;
  left: 0;
  right: 0;
  min-width: 100%;
  max-height: 152px;
  background: #fff;
  overflow: auto;
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  border: 1px solid #e8e8e8;
  -webkit-border-radius: 0 0 5px 5px;
  border-radius: 0 0 5px 5px;
  z-index: 999;
  opacity: 1;
  visibility: visible;
  pointer-events: all;
  -webkit-transform: translateY(0);
  -ms-transform: translateY(0);
  transform: translateY(0);
}
.v-autocomplete-list-item {
  position: relative;
  display: block;
  padding: 10px 20px;
  font-weight: 400;
  color: #3c3c3c;
  -webkit-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  z-index: 9;
}
.prescription-cost{
    font-size: 18px;
    margin-top: 0;
    margin-bottom: 28px;
}

.prescription-cost span{
    color:#842938;
}
.checkbox-text{
  font-size: 12px;
  line-height: 18px;
  max-width: 300px;
  color: #842938;
}
</style>
